// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__M65lM","head":"style_head__xH_D3","content":"style_content__R_hNu"};